import AppHeader from './AppHeader/AppHeader.vue';
import AppFooter from './AppFooter/AppFooter.vue';
import Dashboard from './Dashboard/Dashboard.vue';
import PageGuide from '../Shared/PageGuide.vue';

/* global bootstrap */

export default {
    name: 'layout',

    components: {
        'app-header': AppHeader,
        'app-footer': AppFooter,
        'app-dasboard': Dashboard,
        // Rendered once here rather than pasted into ~55 page templates, so the
        // (i) button sits in exactly the same place on every page.
        'page-guide': PageGuide,
    },

    created() {
        this.$blockUI.$loading = this.$loading;
    },

    mounted() {
        const loadScript = (src, callback) => {
            if (document.querySelector(`script[src="${src}"]`)) {
                if (callback) callback();
                return;
            }
            const script = document.createElement('script');
            script.src = src;
            script.async = true;
            if (callback) script.onload = callback;
            document.body.appendChild(script);
        };

        // 1. Load Bootstrap Bundle (includes Popper.js)
        loadScript('./assets/libs/bootstrap/dist/js/bootstrap.bundle.min.js', () => {
            // Force bootstrap to be global so child components can find it
            window.bootstrap = bootstrap;

            // Now initialize tooltips for the layout
            this.initTooltips();

            // ... load other vendor scripts ...
        });
    },

    methods: {
        initTooltips() {
            // Check if bootstrap exists to prevent ReferenceError
            if (typeof bootstrap !== 'undefined') {
                document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
                    if (!el._tooltipInstance) {
                        el._tooltipInstance = new bootstrap.Tooltip(el);
                    }
                });
            }
        }
    }
};
